import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table"]

  connect() {
    this.element.addEventListener("turbo:before-fetch-response", this.handleResponse.bind(this))
  }

  handleResponse(event) {
    const response = event.detail.fetchResponse
    if (response.succeeded) {
      // Force a refresh of the table after successful action
      const tableId = this.tableTarget.id
      fetch(window.location.href, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const newTable = doc.getElementById(tableId)
        if (newTable) {
          this.tableTarget.innerHTML = newTable.innerHTML
        }
      })
    }
  }
} 